<template>
  <div
    :class="[$style.vgpSvgImage, `${name}-icon`]"
    :style="iconCssVars"
    @click="$emit('onClick', $event)"
  >
    <svg
      :class="$style.vgpSvgImageIcon"
      :viewBox="viewBox"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-html="iconHTML"
    />
  </div>
</template>
<script>
import icons from './imgLibrary/imagesLibrary';

export default {
  name: 'VgpSvgImage',
  props: {
    name: {
      type: String,
      required: true,
      validator(value) {
        return (Object.keys(icons).includes(value));
      },
    },
    width: { type: Number, required: false, default: 0 },
    height: { type: Number, required: false, default: 0 },
    color: { type: String, required: false, default: '' },
  },
  emits: [
    'onClick',
  ],
  data() {
    return {};
  },
  computed: {
    icon() {
      const name = this.name || 'teammate';

      return icons[name] || null;
    },

    iconWidth() {
      return this.width || this.icon?.width || 0;
    },

    iconHeight() {
      return this.height || this.icon?.height || 0;
    },

    iconColor() {
      return this.color || this.icon?.color || 'inherit';
    },
    iconCssVars() {
      return {
        '--vgp-svg-image-width': `${this.iconWidth}px`,
        '--vgp-svg-image-height': `${this.iconHeight}px`,
        '--vgp-svg-image-color': this.iconColor,
      };
    },

    iconHTML() {
      return this.icon?.path || '';
    },

    viewBox() {
      return `${`0 0 ${this.iconWidth} ${this.iconHeight}`}`;
    },
  },
};
</script>
<style module lang="less" src="./styles/vgpSvgImage.less"></style>
